export const WIDGET_TYPES_ARR = [
	"aboutBlue",
	"homeBlue",
	"donate",
	"mental-health-resources",
	"firewire-app",
	"socials",
	"benefits",
	"checkout",
	"streams",
	"streams-preview",
	"upcoming-events",
	"events-calendar",
	"forms-list",
	"form-content-page",
	"form-content-page2",
	"form", // requires formId
	"digital-access",
	"honoru",
	"honoru-featured",
	"officers",
	"directors",
	"gallery",
	"audio",
	"quotes",
	"editor-content",
	"cms-content",
	// "custom-widget-", // e.g custom-widget-associationBenefits
	// collection-
	"collection-chaplains",
	"store",
	"peer-support",
	"form-submissions",
	"ps-home",
	"ps-facilities",
	"ps-agents",
	"ps-admin-monthly-reports",
	"ps-form-submissions",
	"membership",
	"marketplace",
	"marketplace-preview",
	"messages",
	"messages-preview",
	"cms-editor",
	"cms-edit-collection",
	"cms-forms",
	"cms-file-storage",
	"cms-users",
	"cms-pages",
	"stripe-payment",
] as const;
type WidgetTypesTuple = typeof WIDGET_TYPES_ARR;
export type WidgetType = WidgetTypesTuple[number];

export type WidgetConfig = WidgetType | firebase.firestore.DocumentReference;
